<template>
  <div>
    <ViewTemplate :table-props="mappingColumns" :project-param-id="projectParamId" :mapper-param-id="mapperParamId"/>
  </div>
</template>

<script>

import { pageViews, type } from "../utils/util";
import Store from "../vuex/store.js";
import TabContentView from "./TabContentView.vue";
import ViewTemplate from "@/components/ViewTemplate.vue";
export default {
  name: pageViews.ACTIVITYTYPESVIEW,
  methods: {
      setValuesToStore(type) {
          Store.commit("setType", type);
      }
  },
  mounted() {
      this.setValuesToStore(type.MAPPER_ACTIVITIES);
  },
  components: {
    TabContentView,
    ViewTemplate
  },
  data() {
    return {
      uploadConfigs: {
        action: "generator",
        actionLabel: "Generator",
        title: "Mapper Config Generator",
        type: type.MAPPER_ACTIVITIES,
        accept: ".zip",
      },
      mappingColumns: {
        type: type.MAPPER_ACTIVITIES,
        isMultiSelectionAllowed: true,
        defaultSortOrder: { name: "asc", label: "Ascending" },
        defaultSortColumn: { name: "Process", label: "Process" },
        configs: [
          { name: "processLocation", label: "Process Location", order: 1, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "process", label: "Process", order: 2, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "activityType", label: "Activity Type", order: 3, isSortable: true, defaultSelected: true , textAlign: "left"},
          { name: "activityCount", label: "Activity Count", order: 4, isSortable: true, type: "int",defaultSelected: true },
          { name: "isStarter", label: "Is Starter", order: 5, isSortable: true, defaultSelected: true , textAlign: "left"}
        ],
        actions: {
          viewPopup: { label: 'View Output' },
          download: { label: 'Request Download' },
          calculate: { label: 'Calculate Complexity' },
        },
      },
   };
  },
  props: ["projectParamId", "mapperParamId"],
}

</script>
